// extracted by mini-css-extract-plugin
module.exports = {"tableWrap":"EnrolledClinics_tableWrap__1ofBk","actionsCol":"EnrolledClinics_actionsCol__-BQaV"};